import { useIntl } from "react-intl";
import type { DataTableColumn } from "~components/DataTable/types/dataTableColumn.ts";
import { COMPARISON_TYPE_SYMBOLS } from "~pages/LeaderCriteria/constants/comparisonTypeSymbols.ts";
import type { ComparisonType } from "~pages/LeaderCriteria/enums/comparisonType.ts";
import { useGetStatisticFieldLabel } from "~pages/LeaderCriteria/hooks/useGetStatisticFieldLabel.ts";
import { LeaderCriteriaRuleTableColumns } from "~pages/LeaderCriteria/LeaderCriteriaRuleListPage/enums/leaderCriteriaRuleTableColumns.ts";
import type { LeaderCriteriaRule } from "~pages/LeaderCriteria/types/leaderCriteriaRule.ts";

export const useGetLeaderCriteriaRuleTableColumns = (): Array<DataTableColumn<LeaderCriteriaRule>> => {
  const { formatMessage } = useIntl();
  const getStatisticFieldLabel = useGetStatisticFieldLabel();

  return [
    {
      key: LeaderCriteriaRuleTableColumns.ComparisonField,
      title: formatMessage({ id: "comparison.field" }),
      dataIndex: "comparisonField",
      width: 240,
      ellipsis: { showTitle: true },
      render: (comparisonField: string) => getStatisticFieldLabel(comparisonField),
    },
    {
      key: LeaderCriteriaRuleTableColumns.ComparisonType,
      title: formatMessage({ id: "comparison.type" }),
      dataIndex: "comparisonType",
      width: 160,
      render: (comparisonType: ComparisonType) => COMPARISON_TYPE_SYMBOLS[comparisonType] ?? comparisonType,
    },
    {
      key: LeaderCriteriaRuleTableColumns.ComparisonValue,
      title: formatMessage({ id: "comparison.value" }),
      dataIndex: "comparisonValue",
      width: 160,
    },
    {
      key: LeaderCriteriaRuleTableColumns.StatisticField,
      title: formatMessage({ id: "statistic.field" }),
      dataIndex: "statisticField",
      width: 240,
      ellipsis: { showTitle: true },
      render: (statisticField: string) => getStatisticFieldLabel(statisticField),
    },
    {
      key: LeaderCriteriaRuleTableColumns.QualifierId,
      title: formatMessage({ id: "qualifier.id" }),
      dataIndex: "qualifierId",
      copyable: true,
      width: 220,
    },
  ];
};
